import { render, staticRenderFns } from "./ProductCategory.vue?vue&type=template&id=7875c852&"
import script from "./ProductCategory.vue?vue&type=script&lang=ts&"
export * from "./ProductCategory.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports